import { IAvalancheDangerScale, IAvalancheForecast } from 'redux-state/avalanche-advisory/types.js';
import { getDangerConfig } from './get-danger-config.js';
import { getDangerScale } from './get-danger-scale.js';

const getConfig = (
  danger: Array<IAvalancheDangerScale>,
  forecast: IAvalancheForecast,
): {
  high: {
    label: string;
    className: string;
    risk: string;
  };
  mid: {
    label: string;
    className: string;
    risk: string;
  };
  sub: {
    label: string;
    className: string;
    risk: string;
  };
} => {
  const {
    alpine,
    high_alpine: highAlpine,
    sub_alpine: subAlpine,
    high_alpine_from: high,
    alpine_from: midFrom,
    alpine_to: midTo,
    sub_alpine_to: sub,
  } = forecast;

  const highAlpineScale = getDangerScale(danger, highAlpine);
  const alpineScale = getDangerScale(danger, alpine);
  const subAlpineScale = getDangerScale(danger, subAlpine);

  return {
    high: { ...getDangerConfig(highAlpineScale), label: `High Alpine > ${high || 2000}m` },
    mid: { ...getDangerConfig(alpineScale), label: `Alpine ${midFrom || 1000}m - ${midTo || 2000}m` },
    sub: { ...getDangerConfig(subAlpineScale), label: `Sub Alpine < ${sub || 1000}m` },
  };
};

export { getConfig };
